/**
 * VR setup panel: detect dominant hand from the first trigger squeeze.
 */
import { DOMINANT_HAND, type DominantHand } from '../config/constants';
import { getSetting, setSetting } from '../settings/userSettings';

export type { DominantHand };

export function loadDominantHand(): DominantHand {
  const v = getSetting('dominantHand');
  return v === DOMINANT_HAND.left ? DOMINANT_HAND.left : DOMINANT_HAND.right;
}

export function saveDominantHand(hand: DominantHand): void {
  setSetting('dominantHand', hand);
}
